import { useQuery } from '@tanstack/react-query';
import { artiaProtectedApi } from '@/lib/api-client';
import { Meeting, meetingSchema } from '../types/meeting';

export const getMeetingDetails = async (id: number): Promise<Meeting> => {
  try {
    const response = await artiaProtectedApi.get(`/calendar/${id}`);
    
    // Validate and parse the response data using the Zod schema
    const parsedData = meetingSchema.parse(response);
    return parsedData;
  } catch (error) {
    console.error('Error in getMeetingDetails:', error);
    throw error;
  }
};

export const useMeetingDetails = (id?: number, enabled: boolean = true) => {
  return useQuery<Meeting, Error>({
    queryKey: id ? ['meeting-details', id] : ['meeting-details', 'none'],
    queryFn: () => getMeetingDetails(id!),
    enabled: !!id && enabled,
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
};
